import IndustryChecklistI18n from "@/components/landing/shared/IndustryChecklistI18n";
const ChecklistITSection = () => <IndustryChecklistI18n translationPrefix="industryIT" />;
export default ChecklistITSection;
